import React, { useState } from 'react';
import { Banner } from './Pages/Dashboard/Components/Banner/Banner';
import "./MyStyles/iplContest.scss";
import { HowToPlay } from './Pages/Dashboard/Components/HowToPlay/howToPlay';
import { PastWinner } from './Pages/Dashboard/Components/PastWinner/pastWinner';
import { LeaderBoard } from './Pages/Dashboard/Components/LeaderBoard/LeaderBoard';
import { Testimonials } from './Pages/Dashboard/Components/Testimonials/Testimonials';
import { Faqs } from './Pages/Dashboard/Components/Faq/faq';
import { Footer } from './Components/Footer/Footer';

export const IPLContestWatcho = () => {

    const [userData, setuserData] = useState();

    const handleSaveUserData = (mobileNo, ottsmsid) => {
        setuserData({ mobileNo: mobileNo, ottsmsid: ottsmsid })
    }
    return (
        <>
            <div id='home'>
                <Banner handleSaveUserData = {handleSaveUserData} />
            </div>
            <div id='howToPlay'>
                <HowToPlay />
            </div>
            <div id='pastWinners'>
                <PastWinner />
            </div>
            <div id='leaderBoard'>
                <LeaderBoard userData={userData} />
            </div>
            {/* <div id='testimonials'>
                <Testimonials />
            </div> */}
            <div id='faq'>
                <Faqs />
            </div>
            <Footer />
        </>
    );
}